import { useMediaQuery, useTheme } from '@mui/material';

/** Matches TesterShellLayout sidebar/bottom-nav split at md (900px). */
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
